import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

const indicators = [
  'MACD',
  'RSI',
  'EMA Cross',
  'MFI',
  'ADX',
  'Volume Profile',
  'OBV',
  'Bollinger Bands',
];

export default function LogoCollection() {
  return (
    <Container sx={{ py: { xs: 4, sm: 6 } }}>
      <Box
        sx={{
          p: { xs: 2.5, sm: 3 },
          borderRadius: '28px',
          border: '1px solid',
          borderColor: 'divider',
          bgcolor: 'rgba(255,255,255,0.03)',
        }}
      >
        <Typography
          component="p"
          variant="caption"
          align="center"
          color="text.secondary"
          sx={{ display: 'block', mb: 2.5, letterSpacing: 2, textTransform: 'uppercase' }}
        >
          Built around the indicators traders actually use
        </Typography>
        <Grid container spacing={1.25} justifyContent="center">
          {indicators.map((indicator) => (
            <Grid item key={indicator}>
              <Box
                sx={{
                  px: 2,
                  py: 1,
                  borderRadius: '999px',
                  bgcolor: 'rgba(255,255,255,0.04)',
                  border: '1px solid rgba(126, 165, 214, 0.14)',
                }}
              >
                <Typography fontWeight={700} sx={{ letterSpacing: 0.3 }}>
                  {indicator}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
}
